import {
  ModalController
} from 'ionic-angular/components/modal/modal-controller';
import {
  NavParams
} from 'ionic-angular/navigation/nav-params';
import {
  Component,
  ViewChild,
  OnInit,
  Host,
  OnDestroy
} from '@angular/core';
import {
  DocumentCirculationService
} from './../../../../providers/document-circulation.service';
import {
  RunningDocument,
  Provider,
  RunningDocumentInfo,
  LastDates,
  DateInterval
} from '../../model/index';
import {
  Observable
} from 'rxjs/Rx';
import {
  Subscription
} from 'rxjs/Subscription';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  Location
} from '@angular/common';
/*import {
  dns
} from "../../../../providers/global.config";*/
import {
  Events
} from 'ionic-angular/util/events';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  DocCircForm
} from './doc-circ-form/doc-circ-form';
import {
  AlertController
} from 'ionic-angular/components/alert/alert-controller';


@Component({
  templateUrl: 'doc-circ.html'
})
export class DocCirc {
  all: any;
  data: RunningDocumentInfo[] = [];
  startdate: any;
  enddate: any;
  insurance: any;
  index: number;
  addinsurance: RunningDocument
  insuranceProviders: Provider[] = [];
  otherProviders: Provider[] = [];
  listInsurance: RunningDocumentInfo[] = [];
  listVisit: RunningDocumentInfo[] = [];
  listCertification: RunningDocumentInfo[] = [];
  listPermit: RunningDocumentInfo[] = [];
  listTaxe: RunningDocumentInfo[] = [];
  datesExpiration: LastDates = new LastDates();
  idVehicule: any;
  constructor(public navParams: NavParams, public viewCtrl: ViewController, private documentService: DocumentCirculationService, public modalCtrl: ModalController, public alertCtrl: AlertController) {
    this.all = navParams.get('data');
    this.listInsurance = this.all.listInsurance;
    this.insurance = this.all.insurance;
    this.datesExpiration = this.all.datesExpiration;
    this.idVehicule = this.all.idVehicule;
  }
  ngOninit() {
    this.data = this.navParams.get('data');
  }
  ngAfterViewInit() {

  }
  closeModal() {
    this.viewCtrl.dismiss(null)
  }
  update(item: any, i: any) {
    this.index = i;
    item.type = this.insurance.type;
    console.log(item)
    let doccircform = this.modalCtrl.create(DocCircForm, {
      item
    })
    doccircform.present();
    doccircform.onDidDismiss(data => {
      if (data) {
        this.documentService.update(data.insurance, data.idProvider, data.providerName).subscribe((response) => {
          if (data.insurance.type == "INSURANCE") {
            this.insuranceProviders = this.insuranceProviders.filter(provider => provider.id !== response.idProvider);
            let provider: Provider = new Provider();
            provider.id = response.idProvider;
            provider.name = response.providerName;
            this.insuranceProviders.push(provider);
            this.listInsurance = this.listInsurance.filter(insurance => insurance.id !== data.insurance.id);
            this.listInsurance.splice(this.index, 0, response);
            // if (this.datesExpiration.insurance.getTime() < response.endTime) {
            //   this.datesExpiration.insurance = new Date(response.endTime);
            // }
          }
          if (data.insurance.type == "VISIT") {
            this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
            let provider: Provider = new Provider();
            provider.id = response.idProvider;
            provider.name = response.providerName;
            this.otherProviders.push(provider);
            this.listVisit = this.listVisit.filter(visit => visit.id !== data.insurance.id);
            this.listVisit.splice(this.index, 0, response);
            // if (this.datesExpiration.visit.getTime() <response.endTime) {
            //     this.datesExpiration.visit = new Date(response.endTime);
            // }
          }
          if (data.insurance.type == "OPERATIONAL_CERTIFICATION") {
            this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
            let provider: Provider = new Provider();
            provider.id = response.idProvider;
            provider.name = response.providerName;
            this.otherProviders.push(provider);
            this.listCertification = this.listCertification.filter(certification => certification.id !== data.insurance.id);
            this.listCertification.splice(this.index, 0, response);
            // if (this.datesExpiration.certification.getTime() < response.endTime) {
            //     this.datesExpiration.certification = new Date(response.endTime);
            // }
          }
          if (data.insurance.type == "PERMIT_CIRCULATION") {
            this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
            let provider: Provider = new Provider();
            provider.id = response.idProvider;
            provider.name = response.providerName;
            this.otherProviders.push(provider);
            this.listPermit = this.listPermit.filter(permit => permit.id !== data.insurance.id);
            this.listPermit.splice(this.index, 0, response);
            // if (this.datesExpiration.permit.getTime() < response.endTime) {
            //     this.datesExpiration.permit = new Date(response.endTime);
            // }
          }
          if (data.insurance.type == "ROAD_TAXES") {
            this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
            let provider: Provider = new Provider();
            provider.id = response.idProvider;
            provider.name = response.providerName;
            this.otherProviders.push(provider);
            this.listTaxe = this.listTaxe.filter(taxe => taxe.id !== data.insurance.id);
            this.listTaxe.splice(this.index, 0, response);
            // if (this.datesExpiration.taxe.getTime() < response.endTime) {
            //     this.datesExpiration.taxe = new Date(response.endTime);
            // }
          }
          // this.myModalAddClose.nativeElement.click();
          // this.modalInsurance.nativeElement.click();
          // this.showProvider = false;
          // this.providerName = null;
          // this.config();

        })
      }
    });
  }
  add() {
    this.insurance.operationTime = new Date();
    this.insurance.endTime = new Date();
    this.insurance.endTime.setFullYear(this.insurance.endTime.getFullYear() + 1);
    let doccircform = this.modalCtrl.create(DocCircForm, {
      item: this.insurance
    })
    doccircform.present();
    doccircform.onDidDismiss(data => {
      if (data) {
      this.documentService.add(data.insurance, this.idVehicule, data.idProvider, data.providerName).subscribe((response) => {
        if (data.insurance.type == "INSURANCE") {
          this.listInsurance.push(response);
          this.insuranceProviders = this.insuranceProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.insuranceProviders.push(provider);
          this.addProvider(this.insuranceProviders, response.idProvider, response.providerName);
          if (this.datesExpiration.insurance.getTime() < response.endTime) {
            this.datesExpiration.insurance = new Date(response.endTime);
          }
        }
        if (data.insurance.type == "VISIT") {
          this.listInsurance.push(response);
          this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.otherProviders.push(provider);
          if (this.datesExpiration.visit.getTime() < response.endTime) {
            this.datesExpiration.visit = new Date(response.endTime);
          }
        }
        if (data.insurance.type == "OPERATIONAL_CERTIFICATION") {
          this.listInsurance.push(response);
          this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.otherProviders.push(provider);
          if (this.datesExpiration.certification.getTime() < response.endTime) {
            this.datesExpiration.certification = new Date(response.endTime);
          }
        }
        if (data.insurance.type == "PERMIT_CIRCULATION") {
          this.listInsurance.push(response);
          this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.otherProviders.push(provider);
          if (this.datesExpiration.permit.getTime() < response.endTime) {
            this.datesExpiration.permit = new Date(response.endTime);
          }
        }
        if (data.insurance.type == "ROAD_TAXES") {
          this.listInsurance.push(response);
          this.otherProviders = this.otherProviders.filter(provider => provider.id !== response.idProvider);
          let provider: Provider = new Provider();
          provider.id = response.idProvider;
          provider.name = response.providerName;
          this.otherProviders.push(provider);
          if (this.datesExpiration.taxe.getTime() < response.endTime) {
            this.datesExpiration.taxe = new Date(response.endTime);
          }
        }
      }, () => {});
    }

    })
  
  }
  addProvider(list: Provider[], idProvider: number, providerName: string) {
    list = list.filter(provider => provider.id !== idProvider);
    let provider: Provider = new Provider();
    provider.id = idProvider;
    provider.name = providerName;
    list.push(provider);
}
}



// WEBPACK FOOTER //
// ./src/pages/gestion-park/documentcirculation/doc-circ-aff/doc-circ.ts